import React from 'react';
import { Phone, PhoneOff } from 'lucide-react';

export default function CallControls({
  callType,
  customerMood,
  callState,
  onChangeCallType,
  onChangeCustomerMood,
  gender,
  onChangeGender,
  issue,
  onChangeIssue,
  onStart,
  onStop,
  fieldsDisabled = false,
}) {
  const moods = ['Happy', 'Skeptical', 'Anxious', 'Frustrated', 'Disappointed', 'Neutral', 'Difficult'];
  const issues = [
    'Front brakes',
    'Rear brakes', 
    'Tires',
    'Oil leaks',
    'Overheating',
    'Alternator',
    'Battery',
    'Starter motor',
    'Timing belt',
    'Engine misfire',
    'Check engine light',
    'Suspension',
    'Steering',
    'Transmission',
    'Clutch',
    'CV joint',
    'Coolant leak',
    'Power steering leak',
    'Exhaust leak',
    'Sensors'
  ];

  return (
    <div className="call-panel">
      {/* Toolbar */}
      <div className="call-toolbar">
        <label className="field">
          <span className="field-label">Call Type</span>
          <div className="select-wrapper">
            <select
              className="select"
              value={callType}
              onChange={(e) => onChangeCallType(e.target.value)}
            >
              <option>Anytime Script</option>
              <option>Anytime Script - L1</option>
              <option>Anytime Script - L2</option>
              <option>Anytime Script - L3</option>
              <option>Anytime Script - L4</option>
              <option>ISO</option>
              <option>PMI Additionals</option>
              <option>MAINT Maintenance</option>
            </select>
            <span className="select-caret">▾</span>
          </div>
        </label>
        <label className="field">
          <span className="field-label">Customer Gender</span>
          <div className="select-wrapper">
            <select
              className="select"
              value={gender}
              onChange={(e) => onChangeGender(e.target.value)}
              disabled={fieldsDisabled}
            >
              <option value="M">Male</option>
              <option value="F">Female</option>
            </select>
            <span className="select-caret">▾</span>
          </div>
        </label>
        {callType !== 'ISO' && (
          <>
            <div></div>
            <div className="cta" style={{ marginLeft: 'auto' }}>
              {!callState?.active ? (
                <button
                  className="btn btn-primary"
                  onClick={onStart}
                  disabled={callState?.starting}
                  title="Start call"
                >
                  <Phone size={16} />
                  <span style={{ marginLeft: 8 }}>
                    {callState?.starting ? 'Starting…' : 'Start call'}
                  </span>
                </button>
              ) : (
                <button
                  className="btn btn-danger"
                  onClick={onStop}
                  disabled={callState?.stopping}
                  title="Stop call"
                >
                  <PhoneOff size={16} />
                  <span style={{ marginLeft: 8 }}>
                    {callState?.stopping ? 'Stopping…' : 'Stop call'}
                  </span>
                </button>
              )}
            </div>
          </>
        )}
      </div>

      {/* Issue dropdown and button - separate row when ISO is selected */}
      {callType === 'ISO' && (
        <div className="call-toolbar" style={{ marginTop: '10px' }}>
          <label className="field">
            <span className="field-label">Issue</span>
            <div className="select-wrapper">
              <select
                className="select"
                value={issue}
                onChange={(e) => onChangeIssue(e.target.value)}
                disabled={fieldsDisabled}
              >
                <option value="">Select an issue</option>
                {issues.map((issueOption) => (
                  <option key={issueOption} value={issueOption}>
                    {issueOption}
                  </option>
                ))}
              </select>
              <span className="select-caret">▾</span>
            </div>
          </label>
          <div></div>
          <div className="cta" style={{ marginLeft: 'auto' }}>
            {!callState?.active ? (
              <button
                className="btn btn-primary"
                onClick={onStart}
                disabled={callState?.starting}
                title="Start call"
              >
                <Phone size={16} />
                <span style={{ marginLeft: 8 }}>
                  {callState?.starting ? 'Starting…' : 'Start call'}
                </span>
              </button>
            ) : (
              <button
                className="btn btn-danger"
                onClick={onStop}
                disabled={callState?.stopping}
                title="Stop call"
              >
                <PhoneOff size={16} />
                <span style={{ marginLeft: 8 }}>
                  {callState?.stopping ? 'Stopping…' : 'Stop call'}
                </span>
              </button>
            )}
          </div>
        </div>
      )}

      {/* Segmented mood control */}
      <div className="field-label">Customer Mood</div>
      <div className="segmented">
        {moods.map((m) => {
          const active = m === customerMood;
          return (
            <button
              key={m}
              type="button"
              className={`segmented__item ${active ? 'is-active' : ''}`}
              onClick={() => onChangeCustomerMood(m)}
              title={`Set mood: ${m}`}
              disabled={fieldsDisabled}
            >
              {m}
            </button>
          );
        })}
      </div>

      {/* Selection summary (small, muted) */}
      <div className="selection-row">
        <span className="pill">
          Type: <strong>{callType}</strong>
        </span>
        <span className="pill">
          Mood: <strong>{customerMood}</strong>
        </span>
        <span className="pill">
          Gender: <strong>{gender === 'M' ? 'Male' : 'Female'}</strong>
        </span>
        {callType === 'ISO' && issue && (
          <span className="pill">
            Issue: <strong>{issue}</strong>
          </span>
        )}
      </div>
    </div>
  );
}
